// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"Modal_modalContainer__1KXWM","modalContent":"Modal_modalContent__2MN7V","alignTop":"Modal_alignTop__1snBa","close":"Modal_close__sRhdD"};